import CustomHTMLElement from './customHtmlElement';

export default class noResults extends CustomHTMLElement {
    constructor(properties = {}) {
        super({
            message: '',
        });
        this._createPropertyMethods();
        this.setProperties(properties);
        this._template = require('./templates/noResults.handlebars');
    }
}